<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown>
                <template slot="button-content">
                    <i class="cus-clipboard"></i>
                    Wellness Plans
                    <span
                        v-if="activeWellnessPlan > 0"
                        v-b-tooltip.hover.top
                        title="Active Wellness Plans"
                        >({{ activeWellnessPlan }})</span
                    >
                </template>

                <b-dropdown-item @click="loadList(WELLNESS_PLAN.STATUS_ACTIVE)">
                    <i class="cus-clipboard"></i>View Active Plan
                </b-dropdown-item>

                <b-dropdown-item
                    @click="loadList(WELLNESS_PLAN.STATUS_AUTO_RENEWED)"
                >
                    <i class="cus-clipboard"></i>View Auto-renewed Plan
                </b-dropdown-item>

                <b-dropdown-item
                    @click="loadList(WELLNESS_PLAN.STATUS_CANCELLED)"
                >
                    <i class="cus-clipboard"></i>View Cancelled Plan
                </b-dropdown-item>

                <b-dropdown-item
                    @click="loadList(WELLNESS_PLAN.STATUS_EXPIRED)"
                >
                    <i class="cus-clipboard"></i>View Expired Plan
                </b-dropdown-item>

                <div
                    class="dropdown-divider"
                    v-if="statusActive && _hasAccess('patient.wellness.create')"
                ></div>

                <b-dropdown-item
                    v-if="statusActive && _hasAccess('patient.wellness.create')"
                    @click.stop="openModal()"
                >
                    <i class="cus-add"></i> Enroll In Plan
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </template>
        <b-card-text>
            <wellness-plan-list
                :key="componentKey"
                :type="listType"
                :patientId="patientId"
                ref="wellnessPlanList"
            />
        </b-card-text>
    </b-tab>
</template>
<script>
import WellnessPlanList from "@/components/patient-wellness-plans/wellness-list";
import CONSTANTS from "@/constants/wellness_plan";

export default {
    components: {
        WellnessPlanList
    },
    props: {
        patientDetails: {
            type: Object
        }
    },
    data() {
        return {
            listType: 0,
            componentKey: 0,
            WELLNESS_PLAN: CONSTANTS.WELLNESS_PLAN
        };
    },
    computed: {
        statusActive() {
            return this.$store.getters["patient/statusActive"];
        },
        patientId() {
            return this.patientDetails ? this.patientDetails.id : null;
        },
        activeWellnessPlan() {
            let wellnessPlan = this.$store.getters["patient/wellnessPlan"];

            if (wellnessPlan && wellnessPlan.meta) {
                return wellnessPlan.meta.total;
            }

            return 0;
        }
    },
    methods: {
        loadList(type) {
            this.listType = type;
            this.componentKey += 1;
        },
        openModal() {
            this.$store.commit("patient/openModalEnrollInPlan");
        }
    }
};
</script>
